<template>
  <div>
    <transition name="modal">
      <delete-modal
        v-if="showDeleteModal"
        :loading="loadingDelete"
        @close="closeDeleteModal()"
        @confirmDelete="deleteElement"
      ></delete-modal>
    </transition>

    <div v-if="!loading">
      <div v-if="role" class="flex flex-col">
        <div class="card">
          <div class="flex justify-between items-center">
            <p class="font-medium">ID: #{{ role.id }}</p>

            <div class="flex space-x-4 items-center">
              <router-link
                v-if="hasPermission('edit_roles')"
                :to="{
                  name: 'rolesEditForm',
                  params: { id: role.id },
                }"
              >
                <edit-button />
              </router-link>

              <delete-button
                v-if="hasPermission('delete_roles')"
                class="delete-icon-button"
                @click.prevent="openDeleteModal()"
              />
            </div>
          </div>

          <div class="div-line"></div>

          <div class="mt-2 text-sm">
            <p class="font-medium">Nombre</p>
            <p>{{ role.name }}</p>
          </div>

          <p class="font-medium text-sm mt-2">Permisos</p>
          <p
            class="text-sm"
            v-for="permission in role.permissions"
            :key="permission.id"
          >
            - {{ permission.display_name }}
          </p>

          <div class="mt-2 text-sm">
            <p class="font-medium">Fecha de creación</p>
            <p>{{ formatDatetime(role.created_at) }}</p>
          </div>

          <div class="mt-2 text-sm">
            <p class="font-medium">Fecha de última actualización</p>
            <p>{{ formatDatetime(role.updated_at) }}</p>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import deleteMixin from "@/mixins/deleteMixin";
import { formatDatetime } from "@/utils/dateFormatter";
export default {
  name: "Role Detail",

  data() {
    return {
      role: null,
      loading: false,
      loadingDelete: false,
    };
  },

  mixins: [deleteMixin],

  created() {
    this.$store.commit("setSelectedTab", "roles");

    this.loadRole();
  },

  methods: {
    formatDatetime,

    async loadRole() {
      this.loading = true;

      try {
        this.role = await api.roles.getById(this.$route.params.id);
        this.$store.commit('setBreadcrumbLabel', {
          routeName: 'rolesDetail',
          label: this.role.name,
        });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
        this.$router.push({ name: 'rolesIndex' });
      }

      this.loading = false;
    },

    getOptions() {
      let options = [];

      if (this.hasPermission("edit_roles")) {
        options.push({
          action: "edit",
          label: "Editar",
        });
      }

      if (this.hasPermission("delete_roles")) {
        options.push({
          action: "delete",
          label: "Eliminar",
        });
      }

      return options;
    },

    async deleteElement() {
      this.loadingDelete = true;

      try {
        const response = await api.roles.delete(this.role.id);
        this.$store.dispatch("successSnack", response.message);
        this.closeDeleteModal();
        this.$router.push({ name: 'rolesIndex' });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingDelete = false;
    },
  },
};
</script>